export default __webpack_public_path__ + "static/media/img_3.fa8a9cd5.png";